import React, { useEffect } from 'react';
import $ from 'jquery'; // Import jQuery
import 'bootstrap-datepicker'; // Import Bootstrap Datepicker
import PropTypes from 'prop-types'; // Import PropTypes
import "./Accountstatement.css";
import { useTheme } from '@emotion/react';

const DatePickerComponent = ({ Request, handleChange }) => {
    const theme = useTheme();

    useEffect(() => {
        // Initialize date pickers
        $('.datepicker').datepicker({
            format: 'dd/mm/yyyy',
            autoclose: true,
            todayHighlight: true,
        }).on('changeDate', function (e) {
            // Update the state when the date is selected
            const { name } = this; // Use 'this' to get the input element
            handleChange({ target: { name, value: e.format('dd/mm/yyyy') } });
        });

        // Cleanup function to destroy datepicker on unmount
        return () => {
            $('.datepicker').datepicker('destroy');
        };
    }, [handleChange]);

    return (
        <span className='calendar' style={{ color: theme.palette.primary.main }}>
            <label htmlFor="from-date-input" style={{ color: theme.palette.primary.main }}>
                From:
            </label>
            <input
                type="text"
                id="from-date-input"
                name="from"
                className="form-control datepicker"
                placeholder='dd/mm/yyyy'
                value={Request.from || ''}
                onChange={handleChange}
                style={{color: theme.palette.maincolor.light }}
               
            />
            <label htmlFor="to-date-input" style={{ color: theme.palette.primary.main, marginLeft: '1vw' }}>
                To:
            </label>
            <input
                type="text"
                id="to-date-input"
                name="to"
                className="form-control datepicker"
                placeholder='dd/mm/yyyy'
                value={Request.to || ''}
                onChange={handleChange}
                style={{color: theme.palette.maincolor.light }}
            />
        </span>
    );
};

// PropTypes validation
DatePickerComponent.propTypes = {
    Request: PropTypes.shape({
        from: PropTypes.string,
        to: PropTypes.string,
    }).isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default DatePickerComponent;